import React from 'react'

import styles from './styles.module.scss'

import type { ContentLayoutProps } from './types'

export const ContentLayout: React.FC<ContentLayoutProps> = ({ children }) => (
  <div className={ styles.contentLayout }>{ children }</div>
)
